import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MenuItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';
import { ValidateConfirmPassword } from '../../validators/confirmPassword.validator';
import { NgxSpinnerService } from 'ngx-spinner';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { log } from 'util';


@Component({
  selector: 'app-general-information',
  templateUrl: './general-information.component.html',
  styleUrls: ['./general-information.component.scss'],
})
export class GeneralInformationComponent implements OnDestroy, OnInit {

  public slNo: number;

  activeIndex = 0;

  registrationMessageDisplay: boolean;
  registrationResponseMessage: string;

  msgs: Message[] = [];

  minDateOfBirth: Date;
  maxDateOfBirth: Date;
  dateOfBirth: Date;
  maxDateOfBirthYear: number;
  minDateOfBirthYear: number;
  motherTongueId: any;
  registrationForm: FormGroup;
  public mothertongueList = [];
  public categoryList = [];
  public religionList = [];
  public communityList = [];
  public genderList = [];
  public loginIdSelection = [];
  public applicationTo = [];
  public genericList = [];
  public nationalityList = [];
  show: boolean;
  cnfshow: boolean;
  dateMask: any;
  value: any;
  storedDate: any;
  private token: any;
  public disabledField: boolean = false;
  countryId: any;
  stateId: any;
  public allcountrylist = [];
  isOtherState: boolean = true;
  isOtherCity: boolean = true;
  otherOption: boolean = false;
  public stateList = [];
  public cityList = [];
  public maleTitleList = [];
  public femaleTitleList = [];
  public familyIncomeList = [];
  dataList: any;
  isFather = false;
  isMother = false;
  ismlabel = true;
  isflabel = true;
  showclose = false;
  emailRegEx: any;
  disablesubmit = false;
  monthlist = [];
  yearlist = [];
  daylist = [];
  alphaRegEx = "^[a-zA-Z. ]*$";

  castPopup: boolean = false;
  displayModal: boolean;
  displayModal2: boolean;
  confirmCastForm: any;
  setGeneralCaste: boolean = false;
  detailsBox: boolean = false;
  displayDetailsBox: boolean;
  gender: any;
  chk1: any;
  chk2: any;
  chk3: any;
  // chk4: any;
  chk5: any;
  chk6: any;
  submitBtn: boolean = false;
  otpbox: boolean;
  otpValue: any;
  submitWithOtp: boolean = false;
  timeLeftHeading: any;
  timeLeft: number = 120;
  interval: any;
  repeatStep: boolean;
  openOtpBox: boolean = false;
  submitOtpBtn: boolean = true;
  verifyOtp: boolean = false;
  // disableSubmitBtn: boolean = false;
  mobNoVerification = "Mobile number verified successfully";
  preRegMobNo: boolean = false;
  isReadOnly: boolean = false;
  chkMobNo: boolean = false;
  nationalityData: any;
  isOtherNation: boolean = true;
  indians: boolean = false;
  dataConf: any;
  genderQ: string;
  cateQ: any;
  othernationBox: boolean = false;
  whatsapp_template: any;
  whatsapp_no: any;
  whatsapp_bodyValues: any;
  result: any;
  whatsapp_body1: any;
  whatsapp_body2: any;
  whatsapp_body3: any;

  constructor(private renderer: Renderer2, private spinner: NgxSpinnerService, private registrationService: RegistrationService, private router: Router) {
    this.renderer.addClass(document.body, 'general-information-body');
  }


  //private token = JSON.parse(localStorage.getItem('userDetails'));
  ngOnInit() {
    this.emailRegEx = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
    this.show = false;
    this.cnfshow = false;
    this.slNo = 0;
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Please Note :' });
    this.msgs.push({ severity: 'info', detail: '1. All the fields in the below Form are mandatory.' });
    this.msgs.push({ severity: 'info', detail: '<strong>2. Please cross check all the fields specially Category, Gender & Mobile Number before submitting the Form, as these fields are not editable afterwards.</strong>' });
    this.msgs.push({ severity: 'info', detail: '<strong><font color="blue">3.<text-align=right"> After Submission of this form, you will receive an SMS and Email regarding your Application.</text></font></strong>' });
    this.msgs.push({ severity: 'info', detail: '4. <strong><font color="red">Red dot</font></strong> indicates mandatory field.' });
    this.msgs.push({ severity: 'info', detail: '<strong><font color="blue">5.If you are filling up your application form in a cyber cafe, you must clear cache of the browser by selecting Ctrl+Shift+Delete buttons together from the keyboard before filling up your form. Also, you must always remember to logout from your online profile to ensure safety of your data.</font></strong>' });
    /** Date of Birth Selector Configuration Start **/

    const TODAY = new Date();
    // const MONTH = TODAY.getMonth();
    // const YEAR = TODAY.getFullYear();

    // this.maxDateOfBirthYear = YEAR - 14;
    // this.minDateOfBirthYear = YEAR - 35;

    // this.minDateOfBirth = new Date();
    // this.minDateOfBirth.setMonth(MONTH);
    // this.minDateOfBirth.setFullYear(this.minDateOfBirthYear+1);

    // this.maxDateOfBirth = new Date();
    // this.maxDateOfBirth.setMonth(MONTH);
    // this.maxDateOfBirth.setFullYear(this.maxDateOfBirthYear);



    /** Date of Birth Selector Configuration End **/



    this.registrationService.getCommonList().then(commonList => {
      // console.log(commonList);
      this.categoryList = commonList.categoryList;
      // console.log(this.categoryList);
      this.allcountrylist = commonList.allcountrylist;
      this.religionList = commonList.religionList;
      this.nationalityList = commonList.nationalityList;
    });

    this.communityList = [
      {
        'id': 'Yes',
        'name': 'Yes'
      }, {
        'id': 'No',
        'name': 'No'
      }
    ];

    this.genderList = [
      {
        'id': 1,
        'name': 'Female'
      }, {
        'id': 2,
        'name': 'Male'
      }, {
        'id': 3,
        'name': 'Third Gender'
      }
    ];

    this.loginIdSelection = [
      {
        'id': 'email',
        'name': 'Email'
      }, {
        'id': 'mobno',
        'name': 'Mobile No'
      }
    ];

    this.applicationTo = [
      {
        'id': 'ug',
        'name': 'Under Graduate'
      }
    ];

    this.genericList = [
      { id: 'Yes', name: 'Yes' },
      { id: 'No', name: 'No' }
    ];

    let date = new Date;
    let currentyear = date.getFullYear();
    let startyear = currentyear - 35;
    let yearlength = startyear + 23;
    // alert(yearlength);

    for (let i = startyear; i < yearlength; i++) {
      //console.log(i);
      var obj = { "id": i, "name": i };
      this.yearlist.push(obj);
    }

    this.monthlist = [
      { id: 1, name: 'January' },
      { id: 2, name: 'February' },
      { id: 3, name: 'March' },
      { id: 4, name: 'April' },
      { id: 5, name: 'May' },
      { id: 6, name: 'June' },
      { id: 7, name: 'July' },
      { id: 8, name: 'August' },
      { id: 9, name: 'September' },
      { id: 10, name: 'October' },
      { id: 11, name: 'November' },
      { id: 12, name: 'December' },
    ]

    let startday = 1;
    for (let i = startday; i < startday + 31; i++) {
      //console.log(i);
      var obj = { id: i, "name": i };
      this.daylist.push(obj);
    }


    this.registrationForm = new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.pattern(this.alphaRegEx)]),
      middleName: new FormControl('', [Validators.pattern(this.alphaRegEx)]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(this.alphaRegEx)]),
      email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegEx)]),
      day: new FormControl(null, [Validators.required, Validators.max(31)]),
      month: new FormControl(null, Validators.required),
      year: new FormControl(null, Validators.required),
      dateOfBirth: new FormControl(''),
      categoryId: new FormControl(null, Validators.required),
      community: new FormControl('No', Validators.required),
      sexId: new FormControl(null, Validators.required),
      studentPersonalContactNo: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
      loginid: new FormControl('', Validators.required),
      password: new FormControl('', [Validators.required]),
      chkpass: new FormControl('', [ValidateConfirmPassword]),
      applevel: new FormControl('pg', Validators.required),
      residentOfBengal: new FormControl('Yes', Validators.required),
      dfullName: new FormControl(''),
      dGender: new FormControl(''),
      dCategory: new FormControl(''),
      otpNum: new FormControl(''),
      whatsappno: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
      chkCompaireWpMob: new FormControl(this.chkMobNo),
      nationalityId: new FormControl('4', Validators.required),
      othernationality: new FormControl('')
    });

    if (localStorage.getItem('userDetails')) {
      if (localStorage.getItem('userDetails') != "") {
        this.disabledField = true;
        this.patchForm();
      }
    }
    if (localStorage.getItem('meritlisted')) {
      if (localStorage.getItem('meritlisted') === "yes") {
        this.disablesubmit = true;
      }
    }
    if (!localStorage.getItem('step')) {
      if (localStorage.getItem('step') == '') {
        this.showclose = true;
      }
    }
  }

  ngAfterViewInit() {
    if (this.showclose) {
      (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '30px';
    } else {
      (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '40px';
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'general-information-body');
    (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '10px';
  }

  setLoginType() {
    (this.registrationForm.controls['loginid'])
      .setValue((this.registrationForm.controls['studentPersonalContactNo']).value, { onlySelf: true });
  }
  // by jd
  setWhatsappNo() {
    (this.registrationForm.controls['whatsappno'])
      .setValue((this.registrationForm.controls['studentPersonalContactNo']).value, { onlySelf: true });
  }

  // edit by Jd
  onSubmit() {
    // (this.registrationForm.controls['whatsappno']).enable();
    
    if (this.registrationForm.value.nationalityId == '4') {
      this.indians = true;
    } else {
      this.indians = false;
    }
    if (this.isReadOnly == true) {
      this.registrationForm.get('whatsappno').setValue(this.registrationForm.value.loginid);
    }
    if (this.registrationForm.valid) {
      if (this.registrationForm.value.password != this.registrationForm.value.chkpass) {
        alert("Password and Confirm password does not match");
      }
      else if (this.submitWithOtp == false && this.repeatStep != true) {
        this.detailsBox = false;
        alert("Mobile No. needs to be verified before submission of Step 1.");
      }
      else if (this.repeatStep != true) {   // for 1st time proper submit
        this.detailsBox = true;

        // -------------By Att--------------------------
        // const full_name = (this.registrationForm.controls['firstName']).value.toUpperCase() + ' ' + (this.registrationForm.controls['middleName']).value.toUpperCase() + ' ' + (this.registrationForm.controls['lastName']).value.toUpperCase();
        // this.genderList.filter((list) => {
        //   if (list.id == (this.registrationForm.controls['sexId']).value) {
        //     this.genderQ = list.name;
        //   }
        // });
        // this.categoryList.filter((list) => {
        //   if (list.id == (this.registrationForm.controls['categoryId']).value) {
        //     this.cateQ = list.name;
        //   }
        // });

        // this.dataConf = [{ 'name':full_name, 'gender':this.genderQ, 'category':this.cateQ }];
        // console.log(this.dataConf);

        // ---------------------------------------

        (this.registrationForm.controls['dfullName'])
          .setValue((this.registrationForm.controls['firstName']).value.toUpperCase() + ' ' + (this.registrationForm.controls['middleName']).value.toUpperCase() + ' ' + (this.registrationForm.controls['lastName']).value.toUpperCase());

        for (let a of this.genderList) {
          let x = (this.registrationForm.controls['sexId']).value;
          if (a.id == x) {
            (this.registrationForm.controls['dGender'])
              .setValue(a.name);
          }
        };

        for (let b of this.categoryList) {
          let y = (this.registrationForm.controls['categoryId']).value;
          if (b.id == y) {
            (this.registrationForm.controls['dCategory'])
              .setValue(b.name);
          }
        };

      } else if (this.repeatStep == true) {   //repeatstep for login except 1st time
        this.finalSubmit();
      }
    } else {
      console.log('Form Not Submitted!');
      // console.log(this.registrationForm);
      Object.keys(this.registrationForm.controls).forEach(control => {
        this.registrationForm.controls[control].markAsDirty();
      });
    }

  }

  registrationMessageClose() {
    // call auto login and take user to the Academic Info
    this.registrationMessageDisplay = false;
    if (localStorage.getItem('authToken')) {
      this.router.navigateByUrl('admission/academic-information');
    }
  }

  password() {
    this.show = !this.show;
  }

  cnfpassword() {
    this.cnfshow = !this.cnfshow;
  }

  patchForm() {
    this.spinner.show();
    this.token = '';
    this.token = JSON.parse(localStorage.getItem('userDetails'));
    this.registrationForm.patchValue(this.token);
    // console.log(this.token);
    if (this.token.adminlogin !== 2) {          //part of super admin
      this.registrationForm.get('categoryId').disable();
      this.registrationForm.get('sexId').disable();
      this.registrationForm.get('whatsappno').disable();
      this.registrationForm.get('chkCompaireWpMob').disable();
    }
    if (this.token.studentPersonalContactNo == this.token.whatsappno) {
      this.chkMobNo = true;
      this.registrationForm.get('chkCompaireWpMob').setValue(this.chkMobNo);
    }
    if (this.token.lastName == "") {
      this.registrationForm.get('lastName').setValue(" ");
    }
    if (this.token.studentPersonalContactNo != null) {
      this.repeatStep = true;
    }
    this.submitWithOtp = true;
    this.registrationForm.get('loginid').setValue(this.token.studentPersonalContactNo);
    this.registrationForm.get('password').setValue(this.token.dtls);
    this.registrationForm.get('chkpass').setValue(this.token.dtls);

    this.registrationForm.get('day').setValue(this.token.day);
    this.registrationForm.get('month').setValue(this.token.month);
    this.registrationForm.get('year').setValue(this.token.year);
    this.registrationForm.get('applevel').disable();
    this.registrationForm.get('studentPersonalContactNo').disable();
    this.spinner.hide();
  }

  //avoidSpace on email roll no
  avoidSpace(event) {
    let k = event.keyCode;
    if (k == 32) return false;
  }

  avoidNumber(event) {
    if ((event.keyCode >= 97 && event.keyCode <= 122) || (event.keyCode == 32) || (event.keyCode >= 65 && event.keyCode <= 90)) {
    } else {
      return false;
    }
  }

  goToDashboard() {
    this.router.navigate(['candidate/dashboard']);
  }

  onFloatClick() {
    window.open("https://app.botbaba.io/bot/1158ALGR6Xj/BESC%20QBOT");
  }

  checkday() {
    let month = this.registrationForm.value.month;
    let year = this.registrationForm.value.year;
    if (month == '04' || month == '06' || month == '09' || month == '11') {
      if (this.registrationForm.value.day > 30) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
    }

    if (month == '02') {
      if (year % 4 != 0 && this.registrationForm.value.day > 28) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
      else if (year % 4 == 0 && this.registrationForm.value.day > 29) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
    }
  }

  checkMonth() {
    let month = this.registrationForm.value.month;
    let year = this.registrationForm.value.year;
    if (month == '4' || month == '6' || month == '9' || month == '11') {
      if (this.registrationForm.value.day > 30) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
    }
    if (year % 4 != 0 && month == '02') {
      if (this.registrationForm.value.day > 28) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
    }
    if (month == '02') {
      if (year % 4 != 0 && this.registrationForm.value.day > 28) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
      else if (year % 4 == 0 && this.registrationForm.value.day > 29) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
    }
  }

  checkdayMonth() {
    let year = this.registrationForm.value.year;
    let month = this.registrationForm.value.month;
    if (year % 4 != 0 && month == '2') {
      if (this.registrationForm.value.day > 28) {
        alert('Please enter valid day.');
        this.registrationForm.get('day').setValue(null);
      }
    }
  }

  // only numeric get
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  onCategorySelected(castId: number) {
    if (castId > 1) {
      this.castPopup = true;
      this.displayModal = true;
    }
  }

  yesBtn() {
    this.castPopup = false;
    this.displayModal = false;

  }

  noBtn() {
    this.castPopup = false;
    this.displayModal = false;
    this.setGeneralCaste = true;
    this.displayModal2 = true;

  }

  okBtn() {
    this.castPopup = false;
    this.displayModal2 = false;
    this.registrationForm.patchValue({
      categoryId: 1
    });
  }

  // jd
  allCheckedSubmit() {
    if (this.chk1 != 1) {
      return false;
    }
    else {
      this.finalSubmit();
    }
  }

  finalSubmit() {
    this.detailsBox = false;
    // console.log(this.registrationForm);
    this.spinner.show();
    this.registrationForm.get('studentPersonalContactNo').enable();
    const data = this.registrationForm.value;
    data.categoryId = this.registrationForm.value.categoryId;
    data.community = this.registrationForm.value.community;
    data.day = this.registrationForm.value.day;
    data.month = this.registrationForm.value.month;
    data.year = this.registrationForm.value.year;
    data.residentOfBengal = this.registrationForm.value.residentOfBengal;
    data.sexId = this.registrationForm.value.sexId;
    data.applevel = this.registrationForm.value.applevel;
    data.dateOfBirth = data.day + '/' + data.month + '/' + data.year;
    data.whatsappno = this.registrationForm.value.whatsappno;
    // data.nationalityId = this.registrationForm.value.nationalityId;

    if (this.disabledField) {
      this.registrationForm.get('categoryId').enable();
      this.registrationForm.get('sexId').enable();
      this.registrationForm.get('applevel').enable();
      this.registrationForm.get('studentPersonalContactNo').enable();
      this.registrationForm.get('firstName').enable();
      this.registrationForm.get('middleName').enable();
      this.registrationForm.get('lastName').enable();
      data.categoryId = this.registrationForm.controls['categoryId'].value;
      data.sexId = this.registrationForm.controls['sexId'].value;
      data.applevel = this.registrationForm.controls['applevel'].value;
      data.day = this.registrationForm.controls['day'].value;
      data.month = this.registrationForm.controls['month'].value;
      data.year = this.registrationForm.controls['year'].value;
      data.studentPersonalContactNo = this.registrationForm.controls['studentPersonalContactNo'].value;
      data.dateOfBirth = data.day + '/' + data.month + '/' + data.year;
      data.firstName = this.registrationForm.controls['firstName'].value;
      data.middleName = this.registrationForm.controls['middleName'].value;
      data.lastName = this.registrationForm.controls['lastName'].value;
      data.whatsappno = this.registrationForm.controls['whatsappno'].value;

      // console.log(data);
      this.registrationService.updategeneralInfo(localStorage.getItem('authToken'), data).then(res => {
        this.spinner.hide();
        // console.log(res);
        if (res.status === 'success') {
          alert("General Information successfully updated.");
          this.router.navigateByUrl('admission/academic-information');
          localStorage.setItem('userDetails', JSON.stringify(res.userDetails));
          localStorage.setItem('nationality', res.nationalityId);
          if (localStorage.getItem('step') == '')
            this.router.navigateByUrl('candidate/dashboard');
        }
        else {
          alert(res.msg);
          console.log("not valid")
          this.registrationForm.get('categoryId').disable();
          this.registrationForm.get('sexId').disable();
          this.registrationForm.get('applevel').disable();
          this.registrationForm.get('studentPersonalContactNo').disable();
          this.registrationForm.get('whatsappno').disable();
        }
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
      // this.showDetails();
    } else {
      // this.registrationForm.get('studentPersonalContactNo').enable();
      this.registrationService.registerUser(data).then(res => {
        if (res.status === 'success') {
          this.spinner.hide();
          // console.log(data);
          // console.log(res);
          this.result = res;
          // this.whatsapp_template = this.result.whatsapp_template;
          // this.whatsapp_no = this.result.whatsapp_no;
          // this.whatsapp_body1 = this.result.whatsapp_body1;
          // this.whatsapp_body2 = this.result.whatsapp_body2;
          // this.whatsapp_body3 = this.result.whatsapp_body3;

          // this.registrationService.pushWhatsAppNotification(this.whatsapp_template, this.whatsapp_no, this.whatsapp_body1, this.whatsapp_body3, this.whatsapp_body2);
          const dltid = this.result.dltid;
          const mask = this.result.mask;
          const mobno = this.result.mobno;
          const pw = this.result.pw;
          const un = this.result.un;
          const sub = this.result.sub;
          const name = this.result.name;
          const emlbody = this.result.emlbody;
          const emlpw = this.result.emlpw;
          const emlsendto = this.result.emlsendto;
          const emlsub = this.result.emlsub;
          const emlun = this.result.emlun
          this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
            console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              alert(error.message);
            });
          this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
            console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              alert(error.message);
            });
          localStorage.setItem('authToken', res.authToken);
          localStorage.setItem('nationality', this.registrationForm.value.nationalityId);
          // console.log(this.registrationForm.value.nationalityId)
          // if (res.userDetails) {
          //   localStorage.setItem('userDetails', JSON.stringify(res.userDetails));
          // }
          localStorage.setItem('step', res.step);
          this.registrationResponseMessage = res.msg;
          this.registrationMessageDisplay = true;
        }
        else if (res.status === 'failure') {
          this.spinner.hide();
          this.registrationResponseMessage = res.msg;
          this.registrationMessageDisplay = true;
          return false;
        }

      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
    }
  }

  editData() {
    this.detailsBox = false;
  }

  checkGenName(e: boolean) {
    if (e) {
      this.chk1 = 1;

    } else {
      this.chk1 = 0;
    }
   
      if (this.chk1 == 1 && this.chk2 == 1 && this.chk3 == 1 && this.chk6 == 1) {
        this.submitBtn = true;
      }
      else {
        this.submitBtn = false;
        return false;
      }
  }
  checkGenGender(e: boolean) {
    if (e) {
      this.chk2 = 1;
    } else {
      this.chk2 = 0;
    }
      if (this.chk1 == 1 && this.chk2 == 1 && this.chk3 == 1 && this.chk6 == 1) {
        this.submitBtn = true;
      }
      else {
        this.submitBtn = false;
        return false;
      }
  }

  checkGenCategory(e: boolean) {
    if (e) {
      this.chk3 = 1;
    } else {
      this.chk3 = 0;
    }
      if (this.chk1 == 1 && this.chk2 == 1 && this.chk3 == 1 && this.chk6 == 1) {
        this.submitBtn = true;
      }
      else {
        this.submitBtn = false;
        return false;
      }
  }

  finalCheck(e: boolean) {
    if (e) {
      this.chk6 = 1;
    } else {
      this.chk6 = 0;
    }
      if (this.chk1 == 1 && this.chk2 == 1 && this.chk3 == 1 && this.chk6 == 1) {
        this.submitBtn = true;
      }
      else {
        this.submitBtn = false;
        return false;
      }
  }


  forOtp() {
    this.openOtpBox = false;
    // console.log("otp")
    // console.log(this.registrationForm.value.studentPersonalContactNo.length)
    if (this.registrationForm.value.studentPersonalContactNo == '' || this.registrationForm.value.email == '' || this.registrationForm.value.studentPersonalContactNo.length != 10) {
      this.otpbox = false;
      return false;
    }
    else {
      this.registrationForm.get('otpNum').enable();
      this.registrationForm.get('otpNum').setValue(null);
      this.submitOtpBtn = true;
      let mobno = this.registrationForm.value.studentPersonalContactNo;
      let emailid = this.registrationForm.value.email;
      clearInterval(this.interval);
      this.timeLeft = 120;
      this.registrationService.giveOtp(mobno, emailid).then(res => {
        if (res.status == 'success') {
          // console.log(res)
          this.otpValue = res.otp;
          this.otpbox = true;
          const dltid = res.dltid;
          const mask = res.mask;
          const mobno = res.mobno;
          const pw = res.pw;
          const un = res.un;
          const sub = res.sub;
          const name = res.name;
          const emlbody = res.emlbody;
          const emlpw = res.emlpw;
          const emlsendto = res.emlsendto;
          const emlsub = res.emlsub;
          const emlun = res.emlun;
          this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
            console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              alert(error.message);
            });
            this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
              console.log('SMS sent successfully:', response);
            })
              .catch(error => {
                alert(error.message);
              });
        }
        else if (res.status == 'failure') {

          this.otpbox = false;
          this.preRegMobNo = true;
        }
        else {
          alert("Please register first");
        }

      });
      this.interval = setInterval(() => {
        this.timeLeftHeading = true;
        if (this.timeLeft > 0) {
          this.timeLeft--;
        }
        else if (this.timeLeft == 0) {
          this.timeLeftHeading = false;
          // this.otpbox = false;
          this.registrationForm.get('otpNum').disable();
          this.submitOtpBtn = false;
        }
      }, 1000);
      // this.otpbox = true;
    }
  }

  otpback() {
    // console.log(this.registrationForm.value.otpNum);
    if (this.registrationForm.value.otpNum == this.otpValue) {

      this.otpbox = false;
      this.submitWithOtp = true;
      this.verifyOtp = true;
      this.registrationForm.get('studentPersonalContactNo').disable();
    }
    else if (this.registrationForm.value.otpNum == null) {
      return false;

    }
    else {
      alert("OTP Does Not Match! Try Again");
      this.otpbox = false;
    }
  }

  beforeOtpScreen() {
    if (this.registrationForm.value.studentPersonalContactNo == '' || this.registrationForm.value.email == '' || this.registrationForm.value.studentPersonalContactNo.length != 10) {
      this.otpbox = false;
      return false;
    }
    else {
      this.openOtpBox = true;
    }
  }

  backFromOtp() {
    this.verifyOtp = false;
  }

  backFrompreRegMobNo() {
    this.preRegMobNo = false;
  }

  checkSameAsMobNum(e: boolean) {
    if (e) {
      this.isReadOnly = true;
      this.setWhatsappNo();
    }
    else {
      // this.registrationForm.controls['whatsappno'].enable();
      this.isReadOnly = false;
      this.registrationForm.controls['whatsappno'].setValue('');
      return false;
    }
  }

  isOthernationality() {
    const othernationality = this.registrationForm.get("othernationality");
    if (this.registrationForm.value.nationalityId == '15') {
      this.othernationBox = true;
      this.isOtherNation = false;
      othernationality.setValidators([Validators.required, Validators.pattern(this.alphaRegEx)]);
    } else {
      this.registrationForm.controls.othernationality.setValue('');
      this.isOtherNation = true;
      othernationality.clearValidators();
    }
    othernationality.updateValueAndValidity();
  }

  checkWpAsMob() {
    if (this.registrationForm.value.whatsappno === this.registrationForm.value.studentPersonalContactNo) {
      this.chkMobNo = true;
      this.registrationForm.get('chkCompaireWpMob').setValue(this.chkMobNo);
    }
    else {
      this.chkMobNo = false;
      this.registrationForm.get('chkCompaireWpMob').setValue(this.chkMobNo);
    }
  }

  backtoPage() {
    this.othernationBox = false;
  }
}





// WEBPACK FOOTER //
// ./src/app/admission/general-information/general-information.component.ts